import { render } from "./ViewForgotPassword.vue?vue&type=template&id=dda92b8e&ts=true"
import script from "./ViewForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ViewForgotPassword.vue?vue&type=script&lang=ts"

import "./ViewForgotPassword.vue?vue&type=style&index=0&id=dda92b8e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__